import { motion } from 'framer-motion'
import { useState } from 'react'
import MediumContainer from '../../../UI/Container/MediumContainer'
import Navigation from '../Navigation/Navigation'
import { Save, Update } from '../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import { PageType } from '../NawImmoraum'
import { NAWSurvey } from '../../../../types/NAW/Survey'
import Intro from './Intro/Intro'
import Arbeitsplaetze from './Arbeitsplaetze/Arbeitsplaetze'
import Flaeche from './Flaeche/Flaeche'
import Summary from './Summary/Summary'
import Promo from './Promo/Promo'
import styled from 'styled-components'

type Props = {
  survey: NAWSurvey
  update: Update
  save: Save
}

const DefaultPageWrapper = ({ children }) => {
  return <div className="px-0 md:px-10">{children}</div>
}

export const ContentWrapper = styled.div`
  min-height: calc(100vh - 4rem - 20px);
  width: 100%;
  padding: 10vh 0 20vh 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    min-height: auto;
    height: fit-content;
    padding-bottom: 0;
  }
`

export const FullHeightContentWrapper = styled.div`
  height: calc(100vh - 3rem - 20px);
  width: 100%;
  padding: 10vh 0 20vh 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    /* min-height: calc(100vh - 3rem); */
    height: fit-content;
    padding-bottom: 0;
  }
`

const PageList: React.FC<Props> = ({ survey, update, save }) => {
  const [currentPage, setCurrentPage] = useState<PageType>(PageType.INTRO)
  const pages = [PageType.INTRO, PageType.ARBEITSPLAETZE, PageType.FLAECHE, PageType.SUMMARY, PageType.PROMO]
  const surveyPages = [PageType.INTRO, PageType.ARBEITSPLAETZE, PageType.FLAECHE]

  const variants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  }

  const finalize = () => {
    save(PageType.PROMO)
    setCurrentPage(PageType.PROMO)
    window.scrollTo(0, 0)
  }

  const goBack = (page: PageType) => () => setCurrentPage(page)

  return (
    <div className="pt-9 md:pt-12 -mt-12">
      {!!currentPage && surveyPages.includes(currentPage) && (
        <MediumContainer>
          <div className="flex justify-center items-center">
            <motion.div
              key={currentPage}
              className="relative border-opacity-20 bg-white min-w-[50%]"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={variants}
              transition={{ duration: 0.5 }}
            >
              <DefaultPageWrapper>{currentPage === PageType.INTRO && <Intro />}</DefaultPageWrapper>
              <DefaultPageWrapper>{currentPage === PageType.ARBEITSPLAETZE && <Arbeitsplaetze survey={survey} update={update} />}</DefaultPageWrapper>
              <DefaultPageWrapper>{currentPage === PageType.FLAECHE && <Flaeche survey={survey} update={update} />}</DefaultPageWrapper>
            </motion.div>
          </div>
        </MediumContainer>
      )}
      {!!currentPage && currentPage === PageType.SUMMARY && (
        <DefaultPageWrapper>
          {currentPage === PageType.SUMMARY && (
            <Summary survey={survey} update={update} finalize={finalize} backToFlaeche={goBack(PageType.FLAECHE)} />
          )}
        </DefaultPageWrapper>
      )}
      {!!currentPage && currentPage === PageType.PROMO && (
        <div className="px-5 md:px-10 h-full">
          {currentPage === PageType.PROMO && <Promo survey={survey} backToFlaeche={goBack(PageType.SUMMARY)} />}
        </div>
      )}
      <Navigation survey={survey} pages={pages} currentPage={currentPage} setCurrentPage={setCurrentPage} save={save} />
    </div>
  )
}

export default PageList
